import { jsx as _jsx } from "react/jsx-runtime";
var AppleIso = function AppleIso(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#FFFFFF' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "M28.545 20.57a6.697 6.697 0 0 1 3.193-5.583c-1.224-1.735-3.274-2.834-5.407-2.9-2.275-.238-4.48 1.35-5.64 1.35-1.18 0-2.966-1.327-4.888-1.288-2.505.08-4.84 1.494-6.059 3.668-2.62 4.502-.666 11.118 1.844 14.757 1.256 1.782 2.723 3.772 4.643 3.702 1.88-.078 2.581-1.19 4.85-1.19 2.246 0 2.905 1.19 4.864 1.145 2.016-.032 3.287-1.79 4.498-3.589a14.695 14.695 0 0 0 2.057-4.157c-2.37-.995-3.952-3.362-3.955-5.915ZM24.845 9.693A6.518 6.518 0 0 0 26.355 5a6.733 6.733 0 0 0-4.346 2.231 6.26 6.26 0 0 0-1.549 4.52 5.635 5.635 0 0 0 4.385-2.058Z",
      fill: color
    })
  });
};
export default AppleIso;